var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "t-main-content-margin", attrs: { id: "content-primary" } },
    [
      !_vm.membershipProofSent ? _c("div", [_vm._m(0)]) : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "o-width-limiter" }, [
        _c("div", { staticClass: "o-grid" }, [
          _c(
            "div",
            {
              staticClass: "o-grid__column",
              attrs: { "data-size": "sm:12 md:9 lg:9 xl:9" }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "c-buffer-box c-buffer-box--extra-top c-buffer-box--no-bottom",
                  attrs: { id: "checkmembershipform" }
                },
                [
                  _c(
                    "form",
                    {
                      attrs: { name: "form" },
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.handleSendProofOfMembership($event)
                        }
                      }
                    },
                    [
                      _vm.message &&
                      !_vm.membershipProofSent &&
                      !_vm.isVerifiedMember
                        ? _c(
                            "section",
                            {
                              staticClass:
                                "c-info-box c-info-box--very-important",
                              attrs: { id: "failuremessage", role: "alert" },
                              domProps: { innerHTML: _vm._s(_vm.message) }
                            },
                            [
                              _c("span", {
                                domProps: { innerHTML: _vm._s(_vm.message) }
                              })
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isVerifiedMember
                        ? _c(
                            "section",
                            {
                              staticClass: "c-info-box c-info-box--default",
                              attrs: { id: "successmessage", role: "alert" },
                              domProps: { innerHTML: _vm._s(_vm.message) }
                            },
                            [
                              _c("span", {
                                domProps: { innerHTML: _vm._s(_vm.message) }
                              })
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.loading ? _c("div", [_vm._m(1)]) : _vm._e(),
                      _vm._v(" "),
                      !_vm.membershipProofSent
                        ? _c("div", { staticClass: "form-group" }, [
                            _c("div", { staticClass: "c-form__item" }, [
                              _c("div", { staticClass: "c-rect-input" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "c-rect-input__label",
                                    attrs: { for: "text" }
                                  },
                                  [
                                    _vm._v(
                                      "Organisationsnummer (10 siffror)\n                    "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.user.organizationnumber,
                                      expression: "user.organizationnumber"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required: true,
                                        regex: /(?:[0-9]-?){10}/
                                      },
                                      expression:
                                        "{ required: true, regex: /(?:[0-9]-?){10}/ }"
                                    }
                                  ],
                                  staticClass: "c-rect-input__input",
                                  attrs: {
                                    type: "text",
                                    id: "orgnr",
                                    name: "orgnr"
                                  },
                                  domProps: {
                                    value: _vm.user.organizationnumber
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.user,
                                        "organizationnumber",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.errors.first("orgnr")))
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _vm.errors.has("organizationnumber")
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "alert alert-danger",
                                    attrs: { role: "alert" }
                                  },
                                  [
                                    _vm._v(
                                      "Mejladress måste fyllas i!\n                "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.membershipProofSent
                        ? _c("div", { staticClass: "form-group" }, [
                            _c("div", { staticClass: "c-form__item" }, [
                              _c("div", { staticClass: "c-rect-input" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "c-rect-input__label",
                                    attrs: { for: "membershipProofEmail" }
                                  },
                                  [_vm._v("E-post\n                    ")]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.user.membershipProofEmail,
                                      expression: "user.membershipProofEmail"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: { required: true, regex: /.+@.+/ },
                                      expression:
                                        "{ required: true, regex: /.+@.+/ }"
                                    }
                                  ],
                                  staticClass: "c-rect-input__input",
                                  attrs: {
                                    type: "text",
                                    id: "email",
                                    name: "email"
                                  },
                                  domProps: {
                                    value: _vm.user.membershipProofEmail
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.user,
                                        "membershipProofEmail",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.errors.first("email")))
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _vm.errors.has("membershipProofEmail")
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "alert alert-danger",
                                    attrs: { role: "alert" }
                                  },
                                  [
                                    _vm._v(
                                      "Organisationsnummer måste fyllas i!\n                "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.membershipProofSent
                        ? _c("div", { staticClass: "c-form-buttons " }, [
                            _c(
                              "div",
                              { staticClass: "c-form-buttons__button" },
                              [
                                _c("input", {
                                  staticClass: "c-button c-button--primary",
                                  attrs: {
                                    type: "submit",
                                    name: "edit-method",
                                    value: "Nästa",
                                    disabled: _vm.loading,
                                    id: "<?= $submitId ?>"
                                  }
                                })
                              ]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.membershipProofSent
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "form-group o-width-limiter alert alert-success",
                              attrs: { role: "alert" }
                            },
                            [
                              _c(
                                "h2",
                                { staticClass: "c-block-section__heading" },
                                [_vm._v("Nu är det klart!")]
                              ),
                              _vm._v(" "),
                              _c("div", {
                                domProps: { innerHTML: _vm._s(_vm.message) }
                              })
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ]
              )
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "o-width-limiter" }, [
      _c("div", { staticClass: "c-intro" }, [
        _c("div", { staticClass: "o-grid o-grid--space-between" }, [
          _c(
            "div",
            {
              staticClass: "o-grid__column c-intro__preamble",
              attrs: { "data-size": "sm:12 md:6 lg:6 xl:6" }
            },
            [
              _c("div", { staticClass: "s-text preamble" }, [
                _c("h1", { staticClass: "c-intro__heading" }, [
                  _vm._v(
                    "\n                  Hämta medlemsbevis\n                "
                  )
                ]),
                _c("br"),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n                  Ange ditt organisationsnummer och till vilken e-postadress medlemsbeviset ska skickas till.\n                "
                  )
                ])
              ])
            ]
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "c-spinner" }, [
      _c("span", { staticClass: "t-visually-hidden" }, [
        _vm._v("Hämtar ditt bevis")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }